import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const DashboardConfigService = {};

DashboardConfigService.obterConfiguracao = function (usuarioId) {
  return fetch({
    url: `${API_BASE_URL}/DashboardConfig/usuario/${usuarioId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

DashboardConfigService.salvarConfiguracao = function (config) {
  if (config.cards && Array.isArray(config.cards)) {
    config.cards = config.cards.map((card) => {
      let cardInfo = mapCardIdToInfo(card.cardId);

      card.configuracoes = JSON.stringify(cardInfo);

      return card;
    });
  }

  return fetch({
    url: `${API_BASE_URL}/DashboardConfig`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: config,
  });
};

DashboardConfigService.resetarParaPadrao = function (usuarioId) {
  return fetch({
    url: `${API_BASE_URL}/DashboardConfig/usuario/${usuarioId}/reset`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

DashboardConfigService.createDefaultConfig = async function () {
  try {
    const defaultConfig = {
      layout: JSON.stringify([
        { id: "indicadores", title: "INDICADORES" },
        { id: "obras", title: "OBRAS EM ANDAMENTO" },
        { id: "receitas", title: "RECEITAS FUTURAS (PREVISTO)" },
        { id: "solicitacoes_atendimento", title: "SERVIÇOS EM ATENDIMENTO" },
        { id: "solicitacoes_fila", title: "SOLICITAÇÃO DE SERVIÇOS" },
        {
          id: "solicitacoes_finalizados",
          title: "TOTAL DE SERVIÇOS FINALIZADOS",
        },
        { id: "solicitacoes_agua", title: "SOLICITAÇÕES DE ÁGUA" },
        { id: "integrations", title: "INTEGRAÇÕES" },
        { id: "integracao_dinamica", title: "API" },
      ]),
      cards: [
        {
          cardId: 1,
          visivel: true,
          ordem: 1,
          configuracoes: JSON.stringify({ identificador: "perdas_agua" }),
        },
        {
          cardId: 2,
          visivel: true,
          ordem: 2,
          configuracoes: JSON.stringify({ identificador: "alarmes_ativos" }),
        },
        {
          cardId: 3,
          visivel: true,
          ordem: 3,
          configuracoes: JSON.stringify({ identificador: "sem_comunicacao" }),
        },
        {
          cardId: 4,
          visivel: true,
          ordem: 4,
          configuracoes: JSON.stringify({ identificador: "vazao_hora" }),
        },
        {
          cardId: 5,
          visivel: true,
          ordem: 5,
          configuracoes: JSON.stringify({ identificador: "vazao_semana" }),
        },
        {
          cardId: 6,
          visivel: true,
          ordem: 6,
          configuracoes: JSON.stringify({ identificador: "receita_anual" }),
        },
        {
          cardId: 7,
          visivel: true,
          ordem: 7,
          configuracoes: JSON.stringify({ identificador: "obras_agua" }),
        },
        {
          cardId: 8,
          visivel: true,
          ordem: 8,
          configuracoes: JSON.stringify({ identificador: "solicitacoes_fila" }),
        },
        {
          cardId: 9,
          visivel: true,
          ordem: 9,
          configuracoes: JSON.stringify({ identificador: "fila_falta_agua" }),
        },
        {
          cardId: 10,
          visivel: true,
          ordem: 10,
          configuracoes: JSON.stringify({
            identificador: "solicitacoes_atendimento",
          }),
        },
        {
          cardId: 11,
          visivel: true,
          ordem: 11,
          configuracoes: JSON.stringify({
            identificador: "falta_agua_atendimento",
          }),
        },
        {
          cardId: 12,
          visivel: true,
          ordem: 12,
          configuracoes: JSON.stringify({
            identificador: "solicitacoes_finalizadas",
          }),
        },
        {
          cardId: 14,
          visivel: true,
          ordem: 14,
          configuracoes: JSON.stringify({ identificador: "integrations" }),
        },
      ],
    };

    const userId = localStorage.getItem("USER_ID");
    if (!userId) {
      console.error("Não foi possível obter o ID do usuário");
      return null;
    }

    const configToSave = {
      ...defaultConfig,
      usuarioId: parseInt(userId),
      ehPadrao: false,
    };

    return fetch({
      url: `${API_BASE_URL}/DashboardConfig`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: configToSave,
    });
  } catch (error) {
    console.error("Erro ao criar configuração padrão:", error);
    return null;
  }
};

function mapCardIdToInfo(cardId) {
  const cardMapping = {
    1: {
      tipo: "waterLost",
      componenteApp: "WaterLost",
      titulo: "PERDAS DE ÁGUA (IWA)",
      identificador: "perdas_agua",
    },
    2: {
      tipo: "activeAlarms",
      componenteApp: "ActiveAlarms",
      titulo: "ALARMES ATIVOS",
      identificador: "alarmes_ativos",
    },
    3: {
      tipo: "offlineDevices",
      componenteApp: "SimpleWidget",
      titulo: "SEM COMUNICAÇÃO",
      identificador: "sem_comunicacao",
    },
    4: {
      tipo: "averageWaterFlowHourly",
      componenteApp: "WaterFlow",
      titulo: "FLUXO MÉDIO DE ÁGUA (L/S)",
      identificador: "vazao_hora",
    },
    5: {
      tipo: "waterFlowDaily",
      componenteApp: "WaterFlowBars",
      titulo: "VAZÃO DE ÁGUA (L/S)",
      identificador: "vazao_semana",
    },
    6: {
      tipo: "annualRevenue",
      componenteApp: "AnnualRevenue",
      titulo: "RECEITA ANUAL",
      identificador: "receita_anual",
    },
    7: {
      tipo: "waterSewerVolume",
      componenteApp: "WaterLost",
      titulo: "VOLUME DE ÁGUA/ESGOTO",
      identificador: "obras_nao_concluidas",
    },
    8: {
      tipo: "occurrencesQueue",
      componenteApp: "OccurrencesChart",
      titulo: "OCORRÊNCIAS NA FILA",
      identificador: "solicitacoes_fila",
    },
    9: {
      tipo: "occurrencesActive",
      componenteApp: "OccurrencesChart",
      titulo: "OCORRÊNCIAS ATIVAS",
      identificador: "solicitacoes_atendimento",
    },
    10: {
      tipo: "occurrencesTotal",
      componenteApp: "OccurrencesChart",
      titulo: "OCORRÊNCIAS TOTAIS",
      identificador: "solicitacoes_finalizadas",
    },
    11: {
      tipo: "commercialWaterLost",
      componenteApp: "WaterLost",
      titulo: "PERDAS COMERCIAIS",
      identificador: "perdas_agua_comercial",
    },
    12: {
      tipo: "enterpriseStackBar",
      componenteApp: "SimpleWidget",
      titulo: "EMPRESAS",
      identificador: "empreendimentos",
    },
    14: {
      tipo: "integrations",
      componenteApp: "integrations",
      titulo: "INTEGRAÇÕES",
      identificador: "integrations",
    },
  };

  if (typeof cardId === "number" || !isNaN(parseInt(cardId))) {
    const numericId = typeof cardId === "number" ? cardId : parseInt(cardId);
    if (cardMapping[numericId]) {
      return cardMapping[numericId];
    }
  }

  if (typeof cardId === "string") {
    const sectionMappings = {
      indicadores: {
        "component-0": { ...cardMapping[1], identificador: "perdas_agua" }, // Perdas de Água
        "component-vazao-hora": {
          ...cardMapping[4],
          identificador: "vazao_hora",
        },
        "component-vazao-semana": {
          ...cardMapping[5],
          identificador: "vazao_semana",
        },
        "component-1": { ...cardMapping[2], identificador: "alarmes_ativos" }, // Alarmes Ativos
        "component-sem-comunicacao": {
          ...cardMapping[3],
          identificador: "sem_comunicacao",
        },
        "component-perdas-comerciais": {
          ...cardMapping[11],
          identificador: "perdas_agua_comercial",
        },
      },
      obras: {
        "component-0": {
          ...cardMapping[7],
          identificador: "obras_nao_concluidas",
        },
      },
      receitas: {
        "component-0": { ...cardMapping[6], identificador: "receita_anual" }, // Receita Anual
      },
      solicitacoes_fila: {
        "component-0": {
          ...cardMapping[8],
          identificador: "solicitacoes_fila",
        },
      },
      solicitacoes_atendimento: {
        "component-0": {
          ...cardMapping[9],
          identificador: "solicitacoes_atendimento",
        },
      },
      solicitacoes_finalizados: {
        "component-0": {
          ...cardMapping[10],
          identificador: "solicitacoes_finalizadas",
        },
      },
      solicitacoes_agua: {
        "component-0": {
          ...cardMapping[9],
          identificador: "solicitacoes_agua",
        },
      },
    };

    const componentMapping = {
      "indicadores-component-0-component-0-component-0-component-0": {
        identificador: "perdas_agua",
      },
      "indicadores-component-0-component-0-component-0-component-1-component-0":
        {
          identificador: "perdas_agua_comercial",
        },
      "indicadores-component-0-component-0-component-2-component-0": {
        identificador: "vazao_hora",
      },
      "indicadores-component-0-component-1-component-0-component-0": {
        identificador: "vazao_semana",
      },
      "indicadores-component-0-component-1-component-1-component-0": {
        identificador: "alarmes_ativos",
      },
      "indicadores-component-0-component-1-component-1-component-1": {
        identificador: "sem_comunicacao",
      },
      "receitas-component-0-component-0-component-0-component-0": {
        identificador: "receita_anual",
      },
      "receitas-component-0-component-0-component-0-component-1": {
        identificador: "empreendimentos_volume",
      },
      "receitas-component-0-component-0-component-1-component-0": {
        identificador: "empreendimentos_financeiro",
      },
      "receitas-component-0-component-0-component-1-component-1": {
        identificador: "empreendimentos_quantidade",
      },
      "obras-component-0-component-0-component-0-component-0": {
        identificador: "obras_agua",
      },
      "obras-component-0-component-0-component-1-component-0": {
        identificador: "obras_esgoto",
      },
      "solicitacoes_agua-component-0-component-0-component-0-component-0": {
        identificador: "fila_falta_agua",
      },
      "solicitacoes_agua-component-0-component-0-component-1-component-0": {
        identificador: "falta_agua_atendimento",
      },
    };

    if (componentMapping[cardId]) {
      const sectionId = cardId.split("-")[0];
      const sectionInfo = {
        tipo: sectionId,
        componenteWeb: `${
          sectionId.charAt(0).toUpperCase() + sectionId.slice(1)
        }Section`,
        componenteApp: "Generic",
        titulo: `Componente ${sectionId}`,
        identificador: sectionId,
      };

      return {
        ...sectionInfo,
        ...componentMapping[cardId],
      };
    }

    for (const section in sectionMappings) {
      if (cardId.startsWith(`${section}-`)) {
        const componentPart = cardId.substring(section.length + 1);

        for (const compKey in sectionMappings[section]) {
          if (componentPart === compKey || componentPart.startsWith(compKey)) {
            return sectionMappings[section][compKey];
          }
        }
      }
    }

    if (
      cardId === "receitas-component-1" ||
      (cardId.includes("receitas-component-") &&
        cardId.includes("volume-agua-esgoto"))
    ) {
      return {
        tipo: "waterSewerVolume",
        componenteApp: "GroupedBars",
        titulo: "VOLUME DE ÁGUA/ESGOTO",
        identificador: "empreendimentos_volume",
      };
    }

    if (
      cardId.includes("volume-agua-esgoto") ||
      cardId.includes("waterSewerVolume")
    ) {
      return { ...cardMapping[7], identificador: "empreendimentos_volume" }; // Volume de água/esgoto - Identificador corrigido
    }
    if (cardId.includes("perdas-agua") || cardId.includes("waterLost")) {
      return { ...cardMapping[1], identificador: "perdas_agua" }; // Perdas de água
    }
    if (cardId.includes("alarmes") || cardId.includes("alarms")) {
      return { ...cardMapping[2], identificador: "alarmes_ativos" }; // Alarmes ativos
    }
    if (cardId.includes("comunicacao") || cardId.includes("offlineDevices")) {
      return { ...cardMapping[3], identificador: "sem_comunicacao" }; // Dispositivos offline
    }
    if (
      cardId.includes("fluxo-hora") ||
      cardId.includes("averageWaterFlowHourly")
    ) {
      return { ...cardMapping[4], identificador: "vazao_hora" }; // Fluxo médio por hora
    }
    if (cardId.includes("fluxo-diario") || cardId.includes("waterFlowDaily")) {
      return { ...cardMapping[5], identificador: "vazao_semana" }; // Vazão diária
    }
    if (cardId.includes("receita") || cardId.includes("revenue")) {
      return { ...cardMapping[6], identificador: "receita_anual" }; // Receita anual
    }
    if (cardId.includes("fila") || cardId.includes("queue")) {
      return { ...cardMapping[8], identificador: "solicitacoes_fila" }; // Ocorrências na fila
    }
    if (cardId.includes("ocorrencias-ativas") || cardId.includes("active")) {
      return { ...cardMapping[9], identificador: "solicitacoes_atendimento" }; // Ocorrências ativas
    }
    if (cardId.includes("ocorrencias-totais") || cardId.includes("total")) {
      return { ...cardMapping[10], identificador: "solicitacoes_finalizadas" }; // Ocorrências totais
    }
    if (cardId.includes("comercial") || cardId.includes("commercial")) {
      return { ...cardMapping[11], identificador: "perdas_agua_comercial" }; // Perdas comerciais
    }
    if (cardId.includes("empresas") || cardId.includes("enterprise")) {
      return { ...cardMapping[12], identificador: "empreendimentos" }; // Empresas
    }
  }

  return {
    tipo: `tipo-${cardId}`,
    componenteApp: "Desconhecido",
    titulo: `Componente ${cardId}`,
    identificador: `generico_${cardId}`,
  };
}

export default DashboardConfigService;
